'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { persistAttributionFromSearch } from '@/shared/utils/attribution';

export default function AttributionCapture() {
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!searchParams || searchParams.size === 0) {
      return;
    }

    persistAttributionFromSearch(searchParams);
  }, [searchParams]);

  return null;
}
